import { AxiosInstance } from "axios";
import IMFilesPropertyDefinition from "../interfaces/mfiles/IMFilesPropertyDefinition";
import { fetchPropertyDefinitionsUrl, fetchAllObjectClassesUrl, fetchObjectTypeClassesUrl, fetchAllObjectTypesUrl, fetchObjectTypeUrl } from "../helpers/urlHelper";
import { IMfilesObjectClass } from "../interfaces/mfiles/IMfilesObjectClass";
import uniqBy from "lodash/uniqBy";
import { IMFilesObjectType } from "../interfaces/mfiles/IMFilesObjectType";

export const getAllPropertyDefinitionsAsync = async (httpClient: AxiosInstance): Promise<Array<IMFilesPropertyDefinition>> => {
  const url = fetchPropertyDefinitionsUrl();
  const response = await httpClient.get<IMFilesPropertyDefinition[]>(url);
  return response.data;
};

export const getPropertyDefinitionsOfObjectTypes = (
  objectClasses: IMfilesObjectClass[],
  objectTypeIds: number[]
): Map<number, number[]> => {
  const keyValuePairs = [];
  for (const objectTypeId of objectTypeIds) {
    const classesOfObjectType = objectClasses.filter((c) => c.ObjType === objectTypeId);
    const propertyDefinitionsOfObjectType = uniqBy(
      classesOfObjectType.flatMap((c) => c.AssociatedPropertyDefs),
      (c) => c.PropertyDef
    ).map((associatedPropDef) => associatedPropDef.PropertyDef);
    keyValuePairs.push([objectTypeId, propertyDefinitionsOfObjectType]);
  }
  return new Map(keyValuePairs);
};

export const getAllObjectClassesAsync = async (httpClient: AxiosInstance): Promise<Array<IMfilesObjectClass>> => {
  const url = fetchAllObjectClassesUrl();
  const response = await httpClient.get<IMfilesObjectClass[]>(url);
  return response.data;
};

export const getObjectTypeClassesAsync = async (httpClient: AxiosInstance, objectType: number): Promise<Array<IMfilesObjectClass>> => {
  const url = fetchObjectTypeClassesUrl(objectType);
  const response = await httpClient.get<IMfilesObjectClass[]>(url);
  return response.data;
};

export const getAllObjectTypesAsync = async (httpClient: AxiosInstance): Promise<Array<IMFilesObjectType>> => {
  const url = fetchAllObjectTypesUrl();
  const response = await httpClient.get<IMFilesObjectType[]>(url);
  return response.data;
};

export const getObjectTypeAsync = async (httpClient: AxiosInstance, objectType: number): Promise<IMFilesObjectType> => {
  const url = fetchObjectTypeUrl(objectType);
  const response = await httpClient.get<IMFilesObjectType>(url);
  return response.data;
};
